import { EntityType } from '@frontend/common';
import { IdentificationClient } from '@frontend/identification/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useIdentification:request': CustomEvent<string>;
    }
}

const REQUEST_IDENTIFICATION_EVENT = 'useIdentification:request';
const STORAGE_KEY = 'ID_REQ';

export function identificationRequest(identificationId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_IDENTIFICATION_EVENT, { detail: identificationId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function IdentificationResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_IDENTIFICATION_EVENT, EntityType.IDENTIFICATION, (ids) => IdentificationClient.resolveIdentifications(ids), props.dispatch);
    return <></>;
}
